import { useMemo } from 'react';
import { useQuery } from './useQuery';

export type SuccessStateType = {
  claimIds?: string;
  lang?: string;
  resultIndicator?: string;
  sessionVersion?: string;
};

export const usePaymentSuccessQuery = () => {
  const query = useQuery();

  return useMemo<SuccessStateType>(() => {
    const lang = query.get('lang') ?? undefined;
    const resultIndicator = query.get('resultIndicator') ?? undefined;
    const sessionVersion = query.get('sessionVersion') ?? undefined;

    const claimIds = query.get('claimId') ?? '';

    return {
      lang,
      resultIndicator,
      sessionVersion,
      claimIds,
    };
  }, [query]);
};
